module.exports = __webpack_public_path__ + "img/jiqi-0-0.9505d2ef.png";